import { all, takeLatest } from 'redux-saga/effects';

import { CockpitTypes } from '../ducks';
import { registrarEstimuloCockpit } from './cockpitSaga';

import EnvioTypes from '../ducks/protocolo/envio/types';
import * as EnvioSagas from '../ducks/protocolo/envio/sagas';

import BuscaTypes from '../ducks/protocolo/busca/types';
import * as BuscaSagas from '../ducks/protocolo/busca/sagas';

import VisualizarTypes from '../ducks/protocolo/visualizar/types';
import * as VisualizarSagas from '../ducks/protocolo/visualizar/sagas';

import MenuProtocoloTypes from '../ducks/protocolo/menu/types';
import * as MenuProtocoloSagas from '../ducks/protocolo/menu/sagas';

import ExcluirTypes from '../ducks/protocolo/excluir/types';
import * as ExcluirSagas from '../ducks/protocolo/excluir/sagas';

import RecepcaoContratosTypes from '../ducks/protocolo/recepcao_contrato/types';
import * as RecepcaoContratosSagas from '../ducks/protocolo/recepcao_contrato/sagas';

import RecepcionarTypes from '../ducks/protocolo/recepcao/recepcionar/types';
import * as RecepcionarSagas from '../ducks/protocolo/recepcao/recepcionar/sagas';

import CadastrarCaixaTypes from '../ducks/protocolo/recepcao/cadastrarcaixa/types';
import * as CadastrarCaixaSagas from '../ducks/protocolo/recepcao/cadastrarcaixa/sagas';

import UsuariosPreparacaoTypes from '../ducks/protocolo/usuarios_preparacao/types';
import * as UsuariosPreparacaoSagas from '../ducks/protocolo/usuarios_preparacao/sagas';

export default function* rootSaga() {
  return yield all([
    takeLatest(CockpitTypes.REGISTRAR_ESTIMULO_COCKPIT, registrarEstimuloCockpit),
    takeLatest(EnvioTypes.SEARCH_REQUEST, EnvioSagas.searchRequest),
    takeLatest(BuscaTypes.SEARCH_REQUEST, BuscaSagas.search),
    takeLatest(BuscaTypes.SEARCH_FILTERS_REQUEST, BuscaSagas.searchFilters),
    takeLatest(MenuProtocoloTypes.TIPOSAGA, MenuProtocoloSagas.getTipo),
    takeLatest(ExcluirTypes.SEARCH_REQUEST, ExcluirSagas.searchRequest),
    takeLatest(ExcluirTypes.SEARCH_REASON_REQUEST, ExcluirSagas.searchReasonRequest),
    takeLatest(ExcluirTypes.DELETE_REQUEST, ExcluirSagas.deleteRequest),
    takeLatest(VisualizarTypes.VIEW_REQUEST, VisualizarSagas.getView),
    takeLatest(RecepcaoContratosTypes.SEARCH_REQUEST, RecepcaoContratosSagas.searchRequest),
    takeLatest(RecepcaoContratosTypes.RECEPCIONAR_REQUEST, RecepcaoContratosSagas.recepcionarRequest),
    takeLatest(RecepcaoContratosTypes.SEARCH_USUARIOS_REQUEST, RecepcaoContratosSagas.searchUsuarioRequest),
    takeLatest(RecepcionarTypes.SEARCH_REQUEST, RecepcionarSagas.searchRequest),
    takeLatest(CadastrarCaixaTypes.SEQUENCIAL_ORIGINAL_REQUEST, CadastrarCaixaSagas.sequencialOriginalRequest),
    takeLatest(CadastrarCaixaTypes.SEQUENCIAL_COPIA_REQUEST, CadastrarCaixaSagas.sequencialCopiaRequest),
    takeLatest(CadastrarCaixaTypes.INSERT_REQUEST, CadastrarCaixaSagas.insertRequest),
    takeLatest(CadastrarCaixaTypes.SEARCH_CAIXA_REQUEST, CadastrarCaixaSagas.searchCaixaRequest),
    takeLatest(UsuariosPreparacaoTypes.RECOVER_PREPARATIONS, UsuariosPreparacaoSagas.recoverPreparations),
    takeLatest(UsuariosPreparacaoTypes.CREATE_PREPARATION, UsuariosPreparacaoSagas.createPreparation),
    takeLatest(UsuariosPreparacaoTypes.DELETE_PREPARATION, UsuariosPreparacaoSagas.deletePreparation),
    takeLatest(EnvioTypes.SAVE_REQUEST, EnvioSagas.insertRequest),
    takeLatest(EnvioTypes.SEARCH_PROTOCOLO_REQUEST, EnvioSagas.searchProtocoloRequest),
    takeLatest(EnvioTypes.COMPLEMENTO_DOCUMENTOS_PENDENTES, EnvioSagas.documentosPendentes),
    takeLatest(EnvioTypes.PROTOCOLO_MASSA_VALIDAR_REQUEST, EnvioSagas.protocoloMassaValidar),
    takeLatest(BuscaTypes.SEARCH_TOTAIS_REQUEST, BuscaSagas.searchTotais),

  ]);
}
